import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { absenceReasonUnion } from '@/utils/zod'

const responseSchema = z.array(
  z.object({
    value: absenceReasonUnion,
    label: z.string()
  })
)

const useAbsencesReasonOptions = () =>
  useQuery({
    queryKey: ['panelStudentsAbsencesReason'],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelAbsencesOptionsReasonsList()
      return responseSchema.parse(response.results)
    }
  })

export default useAbsencesReasonOptions
